import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FeaturedTemplates = ({ templates, onPreview, onUseTemplate }) => {
  if (!templates || templates?.length === 0) return null;

  return (
    <div className="bg-gradient-to-br from-primary/5 via-accent/5 to-primary/5 border border-border rounded-xl p-4 md:p-6 lg:p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-accent text-accent-foreground rounded-lg flex items-center justify-center">
          <Icon name="Star" size={20} className="fill-current" />
        </div>
        <div>
          <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground">
            Featured Templates
          </h2>
          <p className="text-sm text-muted-foreground">
            Handpicked by our team for exceptional quality
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
        {templates?.map((template) => (
          <div
            key={template?.id}
            className="bg-card border border-border rounded-xl overflow-hidden hover:shadow-lg transition-all duration-250"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
              <div className="relative aspect-[4/3] md:aspect-square overflow-hidden rounded-lg bg-muted">
                <Image
                  src={template?.preview}
                  alt={template?.previewAlt}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-2 right-2 bg-accent text-accent-foreground px-2.5 py-1 rounded-full text-xs font-medium flex items-center gap-1">
                  <Icon name="TrendingUp" size={12} />
                  Trending
                </div>
              </div>

              <div className="flex flex-col justify-between">
                <div>
                  <h3 className="font-heading font-semibold text-lg text-foreground mb-2 line-clamp-1">
                    {template?.name}
                  </h3>
                  <p className="text-sm text-muted-foreground line-clamp-3 mb-3">
                    {template?.description}
                  </p>
                  <div className="flex items-center gap-3 mb-3">
                    <div className="flex items-center gap-1 text-accent">
                      <Icon name="Star" size={14} className="fill-current" />
                      <span className="text-sm font-medium">{template?.rating}</span>
                    </div>
                    <div className="flex items-center gap-1 text-muted-foreground">
                      <Icon name="Download" size={14} />
                      <span className="text-sm">{template?.downloads}</span>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-2">
                  <Button
                    variant="outline"
                    size="sm"
                    iconName="Eye"
                    iconPosition="left"
                    onClick={() => onPreview(template)}
                    className="flex-1"
                  >
                    Preview
                  </Button>
                  <Button
                    variant="default"
                    size="sm"
                    iconName="Rocket"
                    iconPosition="left"
                    onClick={() => onUseTemplate(template)}
                    className="flex-1"
                  >
                    Use Template
                  </Button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturedTemplates;